/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

/**
 * 通用 OSS 上传签名
 * @param {{file_name:string, ext:string, content_type:string, biz?:string}} params
 * @returns {Promise} detail: {signedUrl, url, content_type}
 */
export const getSignedOssUrl = params => {
  return axios.post(`${base}/get_signed_oss_url`, params)
}



// WEBPACK FOOTER //
// ./src/views/oss/oss.api.js